import {
  Modal,
  Form,
  ModalProps,
  FormProps,
  Row,
  Col,
  Input,
  Select,
  useSelect,
  Descriptions,
  Space,
  Icons,
  Button,
  DateField,
  Typography,
  Tag,
} from '@pankod/refine-antd'
import { useCreate, useCreateMany, useGetIdentity, useList, useMany, useOne, useTable } from '@pankod/refine-core'
import { buildPaperRequestNames, getPaperRequestCountsByTrackThisMonth } from 'helpers/paper/paperRequestName'
import {
  IPaperRequest,
  IPaperTemplate,
  IPaperTemplateSubSection,
  IQuestion,
  IQuestionStatus,
  ITestEvent,
  ITestTrack,
  IUser,
  IWorkRequestStatus,
  INotification,
  IProject,
} from 'interfaces'
import paperMetaData from 'metadata/paper'
import React, { useEffect, useState } from 'react'

import { getTestEventById } from 'gql/query'
import paperRequestsMetaData from 'metadata/paperRequests'
import { getLastCreatedPaperRequestList } from 'gql/mutations'
import sendEmail from 'sendmail'
import dayjs from 'dayjs'
import { useUserContext } from 'context/user'

type CreatePaperRequestProps = {
  modalProps: ModalProps
  formProps: FormProps
  record: any
  close?: any
  setCurrentTab?: any
  fetchTestEventDetails?: () => void
}

const { Text } = Typography

export const CreatePaperRequest: React.FC<CreatePaperRequestProps> = ({
  modalProps,
  formProps,
  record,
  close,
  setCurrentTab,
  fetchTestEventDetails,
}) => {
  const { mutateAsync, data: paperRequestMutationReturnData } = useCreate<IPaperRequest>()
  const { data: user } = useGetIdentity()
  const { paperApproverList, paperSetterList } = useUserContext()
  const [assingedTesttracks, setAssignedTestTracks] = useState<any[]>([])
  const [remainingTesttracks, setRemainingTestTracks] = useState<any[]>([])
  const { mutate: createNotifications } = useCreateMany<INotification>()

  //
  let notification_arr: object[] = []
  let mail_arr: object[] = []
  const { selectProps: workrecordStatusSelectProps } = useSelect<IWorkRequestStatus>({
    resource: 'work_request_statuses',
    optionLabel: 'name',
    optionValue: 'id',
    fetchSize: 100,
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    queryOptions: { enabled: !!modalProps?.visible },
  })

  // const { selectProps: projectSelectProps } = useSelect<IProject>({
  //   resource: 'project_config',
  //   fetchSize: 1000,
  //   optionLabel: 'name',
  //   optionValue: 'id',
  //   metaData: {
  //     fields: ['id', 'name'],
  //   },
  //   sort: [{ field: 'name', order: 'asc' }],
  //   onSearch: value => [
  //     {
  //       field: 'name',
  //       operator: 'contains',
  //       value: `${value.toLowerCase()}%`,
  //     },
  //   ],
  // })

  const { data: existingPaperRequests } = useList<IPaperRequest>({
    resource: 'paper_requests',
    config: {
      hasPagination: false,
      filters: [
        {
          field: 'test_event_id',
          operator: 'eq',
          value: record?.id,
        },
      ],
    },
    metaData: {
      fields: ['id', 'test_track_id'],
    },
    queryOptions: {
      enabled: !!record?.id && !!modalProps?.visible,
    },
  })

  const setNotificationAndMailArray = (paper_request: any) => {
    const paperSetterDetails = paperSetterList?.filter((eachUser: any): boolean => {
      return eachUser?.id === paper_request?.paper_setter_id
    })[0]

    mail_arr.push({
      subject: 'A paper request has been created and assigned to you.',
      to: [{ name: `${paperSetterDetails?.displayName}`, email: `${paperSetterDetails?.email}` }],
      htmlContent: `<html><body>Hi,<br/><h4> Paper Request ${paper_request?.name} is created by ${user?.displayName} and assigned to you. You have to set a paper. For more information, Login to <a href="${process.env.REACT_APP_PRODUCTION_URL}" target='_blank'>centa ams</a> .</h4></body></html>`,
    })
    notification_arr.push({
      description: `You are assigned as paper setter for the paper request ${paper_request?.name} `,
      sender: user?.id,
      recepient: paper_request?.paper_setter_id,
      source_name: 'paper_requests',
      title: 'New Task',
      recepient_user_role: 'papersetter',
      redirect_id: paper_request?.id,
      redirect_component: 'show',
    })

    const paperApproverDetails = paperApproverList?.filter((eachUser: any) => {
      return eachUser?.id === paper_request?.paper_approver_id
    })[0]

    mail_arr.push({
      subject: 'A paper request has been created and assigned to you.',
      to: [{ name: `${paperApproverDetails?.displayName}`, email: `${paperApproverDetails?.email}` }],
      htmlContent: `<html><body>Hi,<br/><h4> Paper Request ${paper_request?.name} is created by ${user?.displayName} and assigned to you. You have to approve a paper. For more information, Login to <a href="${process.env.REACT_APP_PRODUCTION_URL}" target='_blank'>centa ams</a> .</h4></body></html>`,
    })
    notification_arr.push({
      description: `You are assigned as paper approver for the paper request ${paper_request?.name} `,
      sender: user?.id,
      recepient: paper_request?.paper_approver_id,
      source_name: 'paper_requests',
      title: 'New Task',
      recepient_user_role: 'paperapprover',
      redirect_id: paper_request?.id,
      redirect_component: 'show',
    })
  }

  const clearSlot = (fieldKey: string | number) => {
    const formInst = formProps?.form?.getFieldsValue()
    const paper_requests = formInst.paper_requests
    Object.assign(paper_requests[fieldKey], { slot_data: '' })
    formProps?.form?.setFieldsValue({ paper_requests })
  }

  const clearPaper = (fieldKey: string | number) => {
    const formInst = formProps?.form?.getFieldsValue()
    const paper_requests = formInst.paper_requests
    Object.assign(paper_requests[fieldKey], { parent_paper_id: null })
    formProps?.form?.setFieldsValue({ paper_requests })
  }

  useEffect(() => {
    if (existingPaperRequests?.data) {
      const _assignedTestTracks = existingPaperRequests.data.map(paperRequest => paperRequest?.test_track_id)
      setAssignedTestTracks(_assignedTestTracks)
    }
  }, [existingPaperRequests?.data])

  useEffect(() => {
    const _remainingTestTracks = record?.product?.test_track_ids?.filter((testTrackId: string) => !assingedTesttracks.includes(testTrackId))
    setRemainingTestTracks(_remainingTestTracks)
  }, [assingedTesttracks])

  const remainingTestTrackData = useMany<ITestTrack>({
    resource: 'test_tracks',
    ids: record?.product?.test_track_ids,
    queryOptions: {
      enabled: !!remainingTesttracks,
    },
    metaData: {
      fields: ['id', 'name', 'subject_ids', 'in_use'],
    },
  })
  //filtering valid test tracks
  const inUseTracks = remainingTestTrackData?.data?.data?.filter(tt => tt.in_use === true) ?? []
  
  const handleRequestChange = () => {
    formProps?.form?.setFieldsValue({ name: 'slot_data', value: '' })
  }
  const onFinish = async (values: any) => {
    const productType = record?.product?.type || ''
    const testTracks = remainingTestTrackData?.data?.data ?? []
    const paperRequests = values?.paper_requests ?? []
    const existingRequests = await getPaperRequestCountsByTrackThisMonth(
      paperRequests.map((paperRequest: { test_track_id?: string }) => paperRequest?.test_track_id || '')
    )
    const paperRequestNames = buildPaperRequestNames(paperRequests, testTracks, existingRequests, productType)

    const result = await Promise.all(
      values?.paper_requests?.map(async (paper_request: any, idx: number) => {
        await mutateAsync({
          resource: 'paper_requests',
          values: {
            name: paperRequestNames[idx],
            description: values?.description,
            status: values?.status,
            // project_id: values?.project_id || null,
            product_id: values?.product_id,
            test_event_id: values?.test_event_id,
            paper_template_id: paper_request?.paper_template_id,
            test_track_id: paper_request?.test_track_id,
            paper_setter_id: paper_request?.paper_setter_id,
            paper_approver_id: paper_request?.paper_approver_id,
            created_by: user?.id,
            slot_data: paper_request?.slot_data,
            request_type: paper_request?.request_type,
            parent_paper_id: paper_request?.parent_paper_id,
          },
        })
      })
    )
    if (fetchTestEventDetails) {
      await fetchTestEventDetails()
    }
    setCurrentTab('1')
    close()
  }

  useEffect(() => {
    console.log(paperRequestMutationReturnData)
  }, [paperRequestMutationReturnData])

  // const letters = Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i))

  return (
    <Modal
      {...modalProps}
      title="Create Test Requests"
      width="80%"
      afterClose={() => {
        formProps?.form?.resetFields()
        formProps?.form?.setFieldsValue({ paper_requests: [] })
      }}
    >
      {JSON.stringify(record) !== '{}' && record?.id !== '' ? (
        <Descriptions size="small" column={3}>
          {record?.name && <Descriptions.Item label="Test Event Name">{record?.name}</Descriptions.Item>}
          {record?.product?.name && <Descriptions.Item label="Product Name">{record?.product?.name}</Descriptions.Item>}
        </Descriptions>
      ) : null}
      <Form
        {...formProps}
        layout="vertical"
        onFinish={values => {
          onFinish(values).then(response => {
            getLastCreatedPaperRequestList(values?.paper_requests?.length)
              .then((resp: any) => {
                console.log('requested last created', resp)
                resp?.paper_requests?.map((request: any) => {
                  setNotificationAndMailArray(request)
                })
              })
              .then(async () => {
                createNotifications({ resource: 'notifications', values: notification_arr })
                await sendEmail(mail_arr)
              })
              .then(() => {
                mail_arr = []
                notification_arr = []
              })
          })
        }}
      >
        <Row gutter={[16, 0]}>
          {/* <Col xs={24} lg={8}>
            <Form.Item
              label="Set Name"
              name="name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input type="hidden" />
              <Select placeholder="Select the SET">
                {letters.map(letter => (
                  <Select.Option key={letter} value={letter}>
                    {letter}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col> */}
          <Col xs={24} lg={16}>
            <Form.Item label="Description" name="description">
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Status" name="status" initialValue={'Open'} rules={[{ required: true }]}>
              <Select {...workrecordStatusSelectProps} />
            </Form.Item>
          </Col>
          {/* <Col xs={24} lg={8}>
            <Form.Item label="Project" name="project_id" rules={[{ required: true, message: 'Please select an project...' }]}>
              <Select {...projectSelectProps} allowClear />
            </Form.Item>
          </Col> */}
        </Row>

        <Row gutter={[16, 0]}>
          <Col lg={24}>
            <Form.List name="paper_requests">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => {
                    return (
                      <IndividualWorkRequest
                        key={key}
                        name={name}
                        restField={restField}
                        remove={remove}
                        productId={record?.product_id}
                        remainingTestTrackData={inUseTracks}
                        paperSetterList={paperSetterList}
                        paperApproverList={paperApproverList}
                        record={record}
                        clearSlot={clearSlot}
                        clearPaper={clearPaper}
                      />
                    )
                  })}
                  {remainingTestTrackData?.data?.data && (
                    <Form.Item>
                      <Button
                        type="dashed"
                        onClick={() => add()}
                        disabled={remainingTestTrackData?.data?.data?.length <= fields?.length}
                        block
                        icon={<Icons.PlusOutlined />}
                        // disabled={paperSetterList.length === selectedPaperSetter.length}
                      >
                        Add Work Request
                      </Button>
                    </Form.Item>
                  )}
                </>
              )}
            </Form.List>
          </Col>
        </Row>
        <Form.Item name="test_event_id" initialValue={record?.id}>
          <Input type="hidden" />
        </Form.Item>
        <Form.Item name="product_id" initialValue={record?.product_id}>
          <Input type="hidden" />
        </Form.Item>
        <Form.Item name="created_by" initialValue={user?.id}>
          <Input type="hidden" />
        </Form.Item>
      </Form>
    </Modal>
  )
}

const IndividualWorkRequest = ({
  name,
  key,
  restField,
  remove,
  productId,
  remainingTestTrackData,
  paperSetterList,
  paperApproverList,
  record,
  clearSlot,
  clearPaper,
}: any) => {
  const [testTrackId, setTestTrackId] = useState<string>('')
  const [paperTemplateId, setPaperTemplateId] = useState<string>('')
  const [slotData, setSlotData] = useState<any[]>([])
  const [paperListShow, setPaperListShow] = useState<boolean>(false)
  const [parentPaperDate, setParentPaperDate] = useState<string>('') //disable based on variant paper.
  const [request, setRequest] = useState<string>('')

  const {
    data: paperTemplatesQueryResult,
    isLoading,
    refetch: refetchTemplates,
  } = useList<IPaperTemplate>({
    resource: 'paper_templates',
    config: {
      filters: [
        {
          field: 'product_id',
          operator: 'eq',
          value: productId,
        },
        {
          field: 'test_track_id',
          operator: 'eq',
          value: testTrackId,
        },
        {
          field: 'is_completed',
          operator: 'eq',
          value: true,
        },
      ],
      hasPagination: false,
    },
    queryOptions: {
      enabled: !!testTrackId,
    },
    metaData: {
      fields: ['id', 'name', 'product_id'],
    },
  })

  const { tableQueryResult: paperQueryResult, setFilters: setPaperFilter } = useTable({
    resource: 'papers',
    metaData: paperMetaData,
    permanentFilter: [
      { field: 'active', operator: 'eq', value: true },
      { field: 'status', operator: 'eq', value: 'Approved' },
    ],
  })
  const listOfPapers = paperQueryResult?.data?.data

  const handlePaperChange = (paperId: string) => {
    const paper = listOfPapers?.filter(paper => paper?.id === paperId)[0]
    console.log('paper found', paper)
    const paperSlotData = JSON.parse(paper?.slot_data)
    setParentPaperDate(JSON.stringify(paperSlotData?.date))
    clearSlot(restField.fieldKey)
  }

  // already selected paper template and test track need to be removed from list
  // same with test_tracks/subject_tracks

  const handleTestTrackChange = (value: string) => {
    setTestTrackId(value)
    setPaperTemplateId('')
    refetchTemplates()

    //change slot data
    //console.log(record)
    let newSlotData: any = []
    // record?.slots?.map((eachSlot: any) => {
    //   if (eachSlot?.id === value) {
    //     for (let key in eachSlot?.slots) {
    //       let timeRange = eachSlot?.slots[key].map((timeSlot: any) => {
    //         return { date: key, time: timeSlot }
    //       })
    //       newSlotData.push(...timeRange)
    //     }
    //   }
    // })
    record?.slots?.map((eachSlot: any) => {
      if (eachSlot?.test_track_id === value) {
        const allSlotsForTestTrack: any[] = eachSlot?.list_of_slots
        newSlotData.push(...allSlotsForTestTrack)
      }
    })
    console.log('newSlotData', newSlotData)
    setSlotData(newSlotData)
  }

  const handlePaperTemplateChange = (value: string) => {
    setPaperTemplateId(value)
    setPaperFilter(
      [
        { field: 'test_event_id', operator: 'eq', value: record?.test_event_id },
        { field: 'paper_template_id', operator: 'eq', value: value },
      ],
      'replace'
    )
  }

  return (
    <Row gutter={[16, 0]}>
      <Col xs={24} lg={4}>
        <Form.Item label="Test Track" {...restField} name={[name, 'test_track_id']} rules={[{ required: true, message: 'Missing Test Track' }]}>
          <Select onChange={value => handleTestTrackChange(value)}>
            {JSON.stringify(remainingTestTrackData) !== '{}' &&
              remainingTestTrackData.map((item: any) => (
                <Select.Option key={item?.id} value={item?.id}>
                  {item?.name}
                </Select.Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
      <Col xs={24} lg={4}>
        <Form.Item
          label="Paper Template"
          {...restField}
          name={[name, 'paper_template_id']}
          rules={[{ required: true, message: 'Missing Paper Template' }]}
        >
          <Select value={paperTemplateId} onChange={value => handlePaperTemplateChange(value)}>
            {paperTemplatesQueryResult?.data?.map(item => (
              <Select.Option key={item?.id} value={item?.id}>
                {item?.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col lg={4}>
        <Form.Item
          label="Paper Setter"
          {...restField}
          name={[name, 'paper_setter_id']}
          rules={[
            {
              required: true,
              message: 'Missing Paper Setter',
            },
          ]}
        >
          <Select>
            {paperSetterList.length > 0 &&
              paperSetterList?.map((item: any) => (
                <Select.Option key={item?.id} value={item?.id}>
                  {item?.displayName}
                </Select.Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
      <Col lg={4}>
        <Form.Item
          label="Paper Approver"
          {...restField}
          name={[name, 'paper_approver_id']}
          rules={[
            {
              required: true,
              message: 'Missing Paper Approver',
            },
          ]}
        >
          <Select>
            {paperApproverList.length > 0 &&
              paperApproverList?.map((item: any) => (
                <Select.Option key={item?.id} value={item?.id}>
                  {item?.displayName}
                </Select.Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
      <Col lg={7}>
        <Form.Item key={key} label="Available Slot" name={[name, 'slot_data']} rules={[{ required: true }]} {...restField}>
          <Select>
            {slotData?.map((data, idx) => {
              const disabled = dayjs(data?.date) < dayjs() || JSON.stringify(data?.date) === parentPaperDate
              console.log('first', data?.date, 'second', parentPaperDate)
              return (
                <option key={idx} value={JSON.stringify(data)} disabled={disabled}>
                  <Space>
                    <DateField value={data?.date} format="LL" disabled={disabled} />
                    <Tag>
                      {/* <Space>
                        <DateField value={data?.time?.[0]} format="LT" disabled={disabled} />
                        <Text disabled={disabled}>To</Text>
                        <DateField value={data?.time?.[1]} format="LT" disabled={disabled} />
                      </Space> */}
                      <Space>
                        <DateField value={data?.start_time} format="LT" disabled={disabled} />
                        <Text disabled={disabled}>To</Text>
                        <DateField value={data?.end_time} format="LT" disabled={disabled} />
                      </Space>
                    </Tag>
                  </Space>
                </option>
              )
            })}
          </Select>
        </Form.Item>
      </Col>

      <Col lg={1} style={{ display: 'flex' }}>
        <Icons.MinusCircleOutlined style={{ marginTop: 'auto', paddingBottom: '16px' }} onClick={() => remove(name)} />
      </Col>
      <Col lg={8}>
        {' '}
        <Form.Item label="Request Type" name={[name, 'request_type']} rules={[{ required: true }]} {...restField} initialValue="normal">
          <Select
            options={[
              { label: 'Variant', value: 'variant' },
              { label: 'Normal', value: 'normal' },
            ]}
            defaultValue={'normal'}
            onChange={value => {
              if (value === 'variant') {
                setPaperListShow(true)
              } else if (value === 'normal') {
                setParentPaperDate('')
                setPaperListShow(false)
              }
              setRequest(value)
              clearSlot(restField.fieldKey)
              clearPaper(restField.fieldKey)
            }}
          ></Select>
        </Form.Item>
      </Col>
      {request === 'variant' ? (
        <Col lg={8}>
          <Form.Item
            label="Select one from below for prefilled Paper"
            name={[name, 'parent_paper_id']}
            {...restField}
            required={request === 'variant' ? true : false}
          >
            <Select
              allowClear
              onChange={(value: any) => {
                handlePaperChange(value)
              }}
              // disabled={!paperListShow}
            >
              {listOfPapers?.map(paper => (
                <option key={paper?.id} value={paper?.id} label={`#${record?.paper_id}`}>
                  #{paper?.paper_id}
                  {paper?.paper_smart_id}
                </option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      ) : (
        <></>
      )}
    </Row>
  )
}
